import { NgModule } from '@angular/core';
import { NgUikitComponent } from './ng-uikit.component';
import {CarouselModule} from './carousel/carousel.module';

@NgModule({
  imports: [
  ],
  declarations: [NgUikitComponent],
})
export class NgUikitModule { }
